import type { TranslationDict } from "./en";
import { guestCheckoutAr } from "./guest-checkout";

export const ar: TranslationDict = {
  common: {
    addToCart: "أضف إلى السلة",
    buyNow: "اشتري الآن",
    viewDetails: "عرض التفاصيل",
    quickView: "معاينة سريعة",
    loading: "جاري التحميل...",
    error: "حدث خطأ",
    search: "البحث عن المنتجات...",
    searchPlaceholder: "ماذا تبحث عنه؟",
    noResults: "لم يتم العثور على نتائج",
    tryAgain: "حاول مرة أخرى",
    yes: "نعم",
    no: "لا",
    cancel: "إلغاء",
    delivery: "التوصيل",
    paymentFee: "رسوم الدفع",
    free: "مجاني",
  },
  product: {
    inStock: "متوفر",
    outOfStock: "غير متوفر",
    lowStock: "{count} فقط متبقية",
    specifications: "المواصفات",
    description: "الوصف",
    reviews: "التقييمات",
    relatedProducts: "منتجات ذات صلة",
    relatedProductsDescription: "اكتشف المنتجات المختارة لك",
    newArrival: "جديد",
    featured: "مميز",
    sale: "تخفيض",
    brand: "العلامة التجارية",
    sku: "رمز المنتج",
    category: "الفئة",
    tags: "الوسوم",
    quantity: "الكمية",
    save: "وفر",
    available: "متاح",
    outOfStockVariant: "غير متوفر",
    selectVariant: "اختر متغير",
    selectVariantMessage: "يرجى اختيار جميع خيارات المتغير قبل الإضافة إلى السلة",
    selectVariantBuyMessage: "يرجى اختيار جميع خيارات المتغير قبل الشراء",
    addedToCart: "تمت الإضافة إلى السلة!",
    productAddedToCart: "تمت إضافة {name} إلى سلتك",
    redirectingToCart: "جاري التوجيه إلى السلة",
    adding: "جاري الإضافة...",
    chooseVariant: "اختر المتغير",
    addToCartFailed: "تعذّرت الإضافة إلى السلة",
    addToCartFailedMessage: "تعذّرت إضافة {name}. يرجى المحاولة مرة أخرى.",
  },
  // Product listings (brand pages, /products, search results)
  listing: {
    filters: "التصفية",
    clearAll: "مسح الكل",
    priceRange: "نطاق السعر",
    sortRelevance: "الأكثر صلة",
    sortPriceAsc: "السعر: من الأقل للأعلى",
    sortPriceDesc: "السعر: من الأعلى للأقل",
    sortNameAsc: "الاسم: أ - ي",
    sortNameDesc: "الاسم: ي - أ",
    sortNewest: "الأحدث أولاً",
    sortPopular: "الأكثر رواجاً",
    noProducts: "لم يتم العثور على منتجات",
    noSearchResults: 'لم يتم العثور على منتجات لـ "{query}". جرّب كلمة بحث مختلفة.',
    noFilterResults: "لا توجد منتجات تطابق عوامل التصفية المحددة. جرّب تعديلها أو مسحها.",
    noBrandProducts: "لم نعثر على أي منتجات لهذه العلامة التجارية.",
    clearSearch: "مسح البحث",
    clearAllFilters: "مسح كل عوامل التصفية",
    searchResultsFor: 'نتائج البحث عن "{query}"',
    searchResultsTitle: "نتائج البحث عن “{query}”",
    products: "المنتجات",
    filtering: "جارٍ تصفية المنتجات...",
    filterCategories: "الفئات",
    filterBrands: "العلامات التجارية",
  },
  pagination: {
    showing: "عرض {from} - {to} من أصل {total}",
    previous: "السابق",
    next: "التالي",
    pageOf: "من {total}",
  },
  cart: {
    title: "عربة التسوق",
    empty: "عربتك فارغة",
    emptyDescription:
      "يبدو أنك لم تضف أي منتج إلى سلتك بعد. ابدأ التسوق لملئها!",
    startShopping: "ابدأ التسوق",
    subtotal: "المجموع الفرعي",
    subtotalItems: "المجموع الفرعي ({count} منتجات)",
    total: "المجموع",
    checkout: "إتمام الطلب",
    continueShopping: "متابعة التسوق",
    remove: "إزالة",
    quantity: "الكمية",
    loadingCart: "جاري تحميل السلة...",
    clearCart: "إفراغ السلة",
    clearConfirm: "حذف جميع المنتجات؟",
    syncing: "جاري تحديث السلة بأحدث الأسعار...",
    itemsUpdated: "تم تحديث بعض المنتجات:",
    itemRemoved: "تمت إزالة {name} من سلتك",
    orderSummary: "ملخص الطلب",
    haveCoupon: "هل لديك كوبون؟",
    enterCode: "أدخل الرمز",
    apply: "تطبيق",
    invalidCoupon: "رمز الكوبون غير صالح",
    couponValidationFailed: "فشل التحقق من الكوبون",
    removeCoupon: "إزالة الكوبون",
    discount: "الخصم",
    coupon: "الكوبون",
    tax: "ضريبة القيمة المضافة",
    shippingAtCheckout: "يتم احتساب الشحن عند إتمام الطلب",
    vatBadge: "ضريبة {percent}%",
    decreaseQuantity: "تقليل الكمية",
    increaseQuantity: "زيادة الكمية",
    removeItem: "إزالة المنتج",
    removeItemTitle: "إزالة المنتج",
    removeItemConfirm:
      'هل أنت متأكد من إزالة "{name}" من سلتك؟ لا يمكن التراجع عن هذا الإجراء.',
    saveAmount: "وفر {amount}",
  },
  checkout: {
    loading: "جاري تحميل صفحة الطلب...",
    title: "إتمام الطلب",
    subtitle: "أكمل طلبك في بضع خطوات فقط",
    backToCart: "العودة إلى السلة",
    processingOrder: "جاري معالجة طلبك",
    processingWait: "يرجى الانتظار بينما نؤكد طلبك...",
    fixErrors: "يرجى تصحيح الأخطاء أدناه",
    noShippingOptions: "لا تتوفر خيارات شحن لهذا العنوان",
    shippingFetchFailed: "فشل جلب خيارات الشحن. يرجى المحاولة مرة أخرى.",
    shippingMethodUnavailable: "طريقة الشحن المختارة غير متاحة",
    fillCustomerInfo: "يرجى تعبئة معلومات العميل",
    completeCustomerForm: "يرجى إكمال نموذج معلومات العميل",
    firstNameRequired: "الاسم الأول مطلوب",
    phoneRequired: "رقم الهاتف مطلوب",
    addressRequired: "العنوان مطلوب",
    cityRequired: "المدينة مطلوبة",
    fillField: "يرجى تعبئة: {field}",
    fillFields:
      "يرجى تعبئة {count} حقول مطلوبة (مرر لأسفل لرؤية الحقول المحددة)",
    fieldFirstName: "الاسم الأول",
    fieldLastName: "اسم العائلة",
    fieldPhone: "الهاتف",
    fieldAddress: "العنوان",
    fieldAddressLine2: "العنوان الإضافي",
    fieldCity: "المدينة",
    fieldPostcode: "الرمز البريدي",
    fieldCountry: "الدولة",
    selectDeliveryMethod: "يرجى اختيار طريقة التوصيل قبل تأكيد طلبك.",
    selectPaymentMethod: "يرجى اختيار طريقة الدفع قبل تأكيد طلبك.",
    paymentMethodUnavailable:
      "طريقة الدفع المختارة غير متاحة. يرجى اختيار طريقة دفع أخرى.",
    transactionIdRequired: "رقم العملية مطلوب للتحقق من الدفع.",
    screenshotRequired: "لقطة شاشة الدفع مطلوبة للتحقق.",
    bankSlipRequired: "إيصال التحويل البنكي مطلوب.",
    orderMissingId:
      "تم إنشاء الطلب لكن المعرف مفقود. يرجى مراجعة سجل طلباتك.",
    bkashInitFailed: "فشل بدء الدفع عبر بيكاش",
    gatewayConnectFailed: "تعذر الاتصال ببوابة الدفع",
    bkashPaymentFailed:
      "فشل الدفع عبر بيكاش: {error}. تم تسجيل طلبك لكنه غير مدفوع بعد — يرجى التواصل مع المتجر لإتمام الدفع.",
    shurjopayPaymentFailed:
      "تم تسجيل طلبك، لكن تعذر بدء الدفع عبر shurjoPay: {error}. الطلب غير مدفوع بعد — يرجى التواصل مع المتجر.",
    orderCreationFailed: "فشل إنشاء الطلب",
    orderProcessingError: "حدث خطأ أثناء معالجة طلبك. يرجى المحاولة مرة أخرى.",
    selectDeliveryLocation: "اختر موقع التوصيل",
    selectLocationHint:
      "يرجى اختيار الدولة والمنطقة والمدينة أعلاه لعرض خيارات الشحن ورسوم التوصيل المتاحة.",
    // CustomerInformationForm
    customerInfo: "معلومات العميل",
    clear: "مسح",
    useSavedAddress: "استخدام عنوان محفوظ",
    addNewAddress: "إضافة عنوان جديد",
    defaultBadge: "افتراضي",
    noteLabel: "ملاحظة:",
    fieldName: "الاسم",
    enterFullName: "أدخل اسمك الكامل",
    addressLabel: "تسمية العنوان",
    labelHome: "المنزل",
    labelWork: "العمل",
    labelOffice: "المكتب",
    labelOther: "أخرى",
    selectLabel: "اختر التسمية",
    addressLine1Label: "العنوان (سطر 1)",
    addressLine1Placeholder: "منزل 123، شارع 45",
    addressLine2Placeholder: "الحي / المنطقة",
    selectCountry: "اختر الدولة",
    divisionState: "المنطقة / الولاية",
    selectDivision: "اختر المنطقة",
    cityDistrict: "المدينة / الحي",
    selectCity: "اختر المدينة",
    optional: "اختياري",
    formatLabel: "الصيغة:",
    deliveryInstructionsOptional: "تعليمات التوصيل (اختياري)",
    deliveryInstructionsPlaceholder: "يرجى الاتصال قبل التوصيل...",
    // DeliveryMethodSelection
    selectDeliveryMethodTitle: "اختر طريقة التوصيل",
    calculatingDelivery: "جاري احتساب رسوم التوصيل...",
    selectDeliveryToContinue: "يرجى اختيار طريقة توصيل للمتابعة",
    homeDelivery: "توصيل للمنزل",
    homeDeliveryDesc: "نوصل طلبك حتى باب منزلك",
    homeDeliveryEta: "3-5 أيام عمل",
    storePickup: "استلام من المتجر",
    storePickupDesc: "استلم طلبك من متجرنا",
    storePickupEta: "جاهز خلال 2-4 ساعات",
    unitMinute: "دقيقة",
    unitMinutes: "دقائق",
    unitDay: "يوم",
    unitDays: "أيام",
    unitHour: "ساعة",
    unitHours: "ساعات",
    unitDayShort: "ي",
    unitHourShort: "س",
    // OrderOverview
    orderOverview: "نظرة عامة على الطلب",
    discountSavings: "وفورات الخصم",
    estDelivery: "التوصيل المتوقع: {time}",
    payableRounded: "المستحق (مقرّب)",
    processing: "جاري المعالجة...",
    confirmOrder: "تأكيد الطلب",
    // CheckoutCouponInput
    couponCode: "رمز الكوبون",
    enterCouponCode: "أدخل رمز الكوبون",
    // PaymentMethodSelection
    selectPaymentMethodTitle: "اختر طريقة الدفع",
    sendPaymentTo: "أرسل الدفع إلى:",
    accountType: "({name} - شخصي/تاجر)",
    transactionId: "رقم العملية",
    enterTrxId: "أدخل رقم العملية (TrxID)",
    screenshot: "لقطة الشاشة",
    uploadScreenshot: "رفع لقطة الشاشة",
    uploadImageFile: "يرجى رفع ملف صورة",
    fileTooLarge: "يجب أن يكون حجم الملف أقل من 10 ميجابايت",
    imageProcessFailed: "فشلت معالجة الصورة",
    uploadImageOrPdf: "يرجى رفع صورة أو ملف PDF",
    bankSlip: "إيصال البنك",
    uploadBankSlip: "رفع إيصال البنك",
    bankLabel: "البنك:",
    nameLabel: "الاسم:",
    accountLabel: "رقم الحساب:",
    branchLabel: "الفرع:",
    notesLabel: "ملاحظات",
    paymentReference: "مرجع الدفع",
    cashOnDelivery: "الدفع عند الاستلام",
    onlinePayment: "دفع إلكتروني",
    offlinePayment: "طرق دفع أخرى",
  },
  orderSuccess: {
    title: "تم تأكيد الطلب!",
    subtitle: "شكراً لطلبك. لقد استلمناه وسنقوم بمعالجته قريباً.",
    orderDetails: "تفاصيل الطلب",
    orderIdLabel: "معرف الطلب:",
    orderStatus: "حالة الطلب",
    paymentStatus: "حالة الدفع",
    paymentMethod: "طريقة الدفع",
    totalItems: "إجمالي المنتجات",
    estimatedDelivery: "التوصيل المتوقع",
    confirmationEmailSent: "تم إرسال بريد تأكيد إلى",
    orderPlacedOn: "تم تقديم الطلب في {date}",
    deliveryInfo: "معلومات التوصيل",
    phoneLabel: "الهاتف:",
    emailLabel: "البريد الإلكتروني:",
    orderItems: "منتجات الطلب ({count})",
    variantLabel: "النوع: {variant}",
    qty: "الكمية: {quantity}",
    perUnitDiscount: "-{amount}/للوحدة",
    vatIncluded: "شامل الضريبة: {amount}",
    whatNext: "ماذا يحدث بعد ذلك؟",
    confirmEmailNote: "ستصلك رسالة تأكيد الطلب على",
    trackingNote: "سنرسل لك معلومات التتبع بمجرد شحن طلبك",
    expectedDelivery: "التوصيل المتوقع: {date}",
    processedSoon: "سيتم معالجة طلبك وشحنه قريباً",
    codNote: "سيتم تحصيل الدفع عند التوصيل",
    downloadPdf: "تحميل PDF",
    backToHome: "العودة إلى الرئيسية",
    pdfFailed: "فشل إنشاء ملف PDF. يرجى المحاولة مرة أخرى.",
  },
  payment: {
    title: "إتمام الدفع",
    subtitle: "أنت على بعد خطوة واحدة من إكمال طلبك",
    backToCheckout: "العودة إلى إتمام الطلب",
    totalAmount: "المبلغ الإجمالي",
    demoNotice: "هذه صفحة دفع تجريبية. لن تتم معالجة أي دفع فعلي.",
    cardNumber: "رقم البطاقة",
    expiryDate: "تاريخ الانتهاء",
    cvv: "رمز الأمان (CVV)",
    processing: "جاري معالجة الدفع...",
    payAmount: "ادفع {amount}",
    sslNotice: "🔒 المدفوعات مؤمنة بتشفير SSL بمعيار 256-بت",
    failed: "فشل الدفع. يرجى المحاولة مرة أخرى.",
  },
  // The page a shopper returns to from an online payment gateway (shurjoPay).
  gatewayReturn: {
    processingTitle: "جارٍ تأكيد الدفع",
    processing: "نتحقق من الدفع لدى shurjoPay. يستغرق ذلك بضع ثوانٍ.",
    paidTitle: "تم الدفع بنجاح",
    paid: "تم استلام دفعتك وتأكيد طلبك.",
    redirecting: "جارٍ نقلك إلى طلبك...",
    pendingTitle: "لم يكتمل الدفع بعد",
    pending: "لم يؤكد shurjoPay هذه الدفعة بعد. إذا أتممت الدفع، فتحقق مرة أخرى بعد دقيقة.",
    mismatchTitle: "الدفعة تحتاج إلى مراجعة",
    mismatch: "أبلغ shurjoPay عن دفعة لا تطابق إجمالي طلبك. لم يُسجَّل طلبك مدفوعًا بعد، ولدى المتجر التفاصيل وسيتواصل معك.",
    cancelledTitle: "تم إلغاء الدفع",
    cancelled: "لقد ألغيت الدفع. طلبك محفوظ لكنه غير مدفوع.",
    failedTitle: "فشل الدفع",
    failed: "لم يقبل shurjoPay الدفعة. طلبك محفوظ لكنه غير مدفوع.",
    errorTitle: "تعذر تأكيد الدفع",
    error: "تعذر تأكيد هذه الدفعة الآن. إذا خُصم المبلغ من حسابك، فتحقق مرة أخرى بعد دقيقة أو تواصل مع المتجر.",
    sessionMissing: "بدأت هذه الدفعة في متصفح آخر، أو انتهت صلاحية الجلسة. راجع طلباتك لمعرفة حالتها.",
    checkAgain: "تحقق مرة أخرى",
    viewOrders: "عرض طلباتي",
    backToShop: "العودة إلى المتجر",
  },
  header: {
    home: "الرئيسية",
    shop: "المتجر",
    categories: "الفئات",
    brands: "العلامات التجارية",
    account: "حسابي",
    login: "تسجيل الدخول",
    logout: "تسجيل الخروج",
    wishlist: "المفضلة",
    cart: "السلة",
    blog: "المدونة",
  },
  auth: {
    // Shared fields
    emailLabel: "البريد الإلكتروني",
    emailPlaceholder: "your@email.com",
    passwordLabel: "كلمة المرور",
    confirmPasswordLabel: "تأكيد كلمة المرور",
    passwordHint: "يجب أن تكون 8 أحرف على الأقل",
    signIn: "تسجيل الدخول",
    signInLink: "تسجيل الدخول",
    signingIn: "جاري تسجيل الدخول...",
    genericError: "حدث خطأ. يرجى المحاولة مرة أخرى.",
    genericErrorLater: "حدث خطأ. يرجى المحاولة لاحقاً.",
    invalidEmail: "البريد الإلكتروني غير صالح",
    invalidPassword: "كلمة المرور غير صالحة",
    // Login
    welcomeBack: "مرحباً بعودتك",
    signInSubtitle: "سجّل الدخول إلى حسابك للمتابعة",
    rememberMe: "تذكرني",
    forgotPasswordLink: "هل نسيت كلمة المرور؟",
    sessionExpired: "انتهت صلاحية جلستك. يرجى تسجيل الدخول مرة أخرى.",
    loginSuccess: "تم تسجيل الدخول بنجاح! جاري التحويل...",
    loginFailed: "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.",
    saveLoginFailed: "تعذر حفظ بيانات الدخول. يرجى المحاولة مرة أخرى.",
    invalidPasswordFormat: "صيغة كلمة المرور غير صالحة",
    noAccount: "ليس لديك حساب؟",
    signUpNow: "سجّل الآن",
    // Signup
    createAccount: "إنشاء حساب",
    signupSubtitle: "انضم إلينا وابدأ رحلة التسوق",
    nameLabel: "الاسم الكامل",
    namePlaceholder: "محمد عبدالله",
    phoneLabel: "رقم الجوال",
    phonePlaceholder: "05x xxx xxxx",
    agreeToTermsPrefix: "أوافق على",
    agreeToTermsSuffix: "",
    termsAndConditions: "الشروط والأحكام",
    and: "و",
    privacyPolicy: "سياسة الخصوصية",
    errNameMin: "يجب أن يتكون الاسم من حرفين على الأقل",
    errEmailRequired: "البريد الإلكتروني مطلوب",
    errEmailInvalid: "البريد الإلكتروني غير صحيح",
    errPhoneRequired: "رقم الجوال مطلوب",
    errPhoneInvalid: "أدخل رقم جوال صحيحاً",
    errPasswordRequired: "كلمة المرور مطلوبة",
    errPasswordMin: "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
    errConfirmPasswordRequired: "يرجى تأكيد كلمة المرور",
    errPasswordsMismatch: "كلمتا المرور غير متطابقتين",
    errTermsRequired: "يجب الموافقة على الشروط والأحكام",
    fixValidationErrors: "يرجى تصحيح الأخطاء أدناه",
    otpSendFailed: "تعذر إرسال رمز التحقق.",
    otpSendFailedRetry: "تعذر إرسال رمز التحقق. يرجى المحاولة مرة أخرى.",
    signupFailed: "فشل إنشاء الحساب. يرجى المحاولة مرة أخرى.",
    phoneVerified: "تم التحقق من رقم الجوال!",
    creatingAccount: "جاري إنشاء حسابك...",
    accountCreated: "تم إنشاء الحساب بنجاح! جاري التحويل...",
    sendingCode: "جاري إرسال رمز التحقق...",
    alreadyHaveAccount: "لديك حساب بالفعل؟",
    // Mobile OTP auth (mobile-only tenants)
    mobileSignInSubtitle:
      "سجّل الدخول برقم جوالك — سنرسل لك رمز التحقق برسالة نصية.",
    mobileNumberLabel: "رقم الجوال",
    sendVerificationCode: "إرسال رمز التحقق",
    signingYouIn: "جاري تسجيل دخولك…",
    getStarted: "ابدأ الآن",
    mobileSignupSubtitle:
      "تسوّق أسرع باسمك ورقم جوالك فقط. لا حاجة لبريد إلكتروني أو كلمة مرور — سنتحقق منك برمز سريع عبر رسالة نصية.",
    creatingYourAccount: "جاري إنشاء حسابك…",
    createOne: "أنشئ حساباً",
    verifyYourPhone: "تحقق من رقم جوالك",
    otpSentTo: "أرسلنا رمزاً مكوناً من 6 أرقام إلى",
    verifyCode: "تحقق من الرمز",
    verifying: "جاري التحقق...",
    verifiedCreating: "تم التحقق! جاري إنشاء الحساب...",
    resendIn: "إعادة إرسال الرمز خلال {time}",
    resendCode: "إعادة إرسال الرمز",
    changePhoneNumber: "تغيير رقم الجوال",
    errOtpEnter6: "يرجى إدخال الرمز المكوّن من 6 أرقام",
    errOtpResendFailed: "تعذر إعادة إرسال رمز التحقق.",
    errOtpInvalid: "رمز التحقق غير صحيح. يرجى المحاولة مرة أخرى.",
    errVerificationFailed: "فشل التحقق. يرجى المحاولة مرة أخرى.",
    // Forgot password
    forgotTitle: "نسيت كلمة المرور",
    forgotSubtitle:
      "أدخل بريدك الإلكتروني وسنرسل لك رابطاً لإعادة تعيين كلمة المرور.",
    checkYourEmail: "تحقق من بريدك الإلكتروني",
    resetLinkSentTo: "أرسلنا رابط إعادة تعيين كلمة المرور إلى",
    checkSpam:
      "لم تستلم الرسالة؟ تحقق من مجلد الرسائل غير المرغوب فيها أو حاول مرة أخرى.",
    tryAnotherEmail: "جرّب بريداً إلكترونياً آخر",
    sending: "جاري الإرسال...",
    sendResetLink: "إرسال رابط إعادة التعيين",
    rememberPassword: "تذكرت كلمة المرور؟",
    // Reset password
    resetTitle: "إعادة تعيين كلمة المرور",
    resetSubtitle: "أدخل كلمة المرور الجديدة أدناه.",
    newPasswordLabel: "كلمة المرور الجديدة",
    newPasswordPlaceholder: "أدخل كلمة المرور الجديدة",
    confirmNewPasswordPlaceholder: "أكّد كلمة المرور الجديدة",
    invalidResetLink: "رابط إعادة التعيين غير صالح",
    invalidResetLinkDesc:
      "رابط إعادة تعيين كلمة المرور غير صالح أو منتهي الصلاحية.",
    requestNewLinkHint: "يرجى طلب رابط جديد لإعادة تعيين كلمة المرور.",
    requestNewLink: "طلب رابط جديد",
    resetSuccessTitle: "تمت إعادة تعيين كلمة المرور بنجاح",
    resetSuccessDesc:
      "تمت إعادة تعيين كلمة المرور. جاري التحويل إلى تسجيل الدخول...",
    goToLogin: "الذهاب إلى تسجيل الدخول",
    resettingPassword: "جاري إعادة تعيين كلمة المرور...",
    // Email verification
    verifyingEmail: "جاري التحقق من بريدك الإلكتروني...",
    emailVerifiedTitle: "تم التحقق من البريد الإلكتروني",
    emailVerifiedDesc: "تم التحقق من بريدك الإلكتروني بنجاح.",
    continueToCheckout: "المتابعة إلى إتمام الطلب",
    continueToLogin: "المتابعة إلى تسجيل الدخول",
    verifyFailedTitle: "فشل التحقق",
    verifyFailedDesc: "رابط التحقق غير صالح أو منتهي الصلاحية.",
    verifyFailedHint:
      "سجّل الدخول إلى حسابك وأعد إرسال رسالة تحقق جديدة من صفحة إتمام الطلب.",
    // Checkout verification gate
    verificationRequiredTitle: "تحقق من حسابك",
    verificationRequiredDesc:
      "يرجى التحقق من بريدك الإلكتروني قبل إتمام الطلب. سنرسل رابط التحقق إلى:",
    resendVerification: "إعادة إرسال رسالة التحقق",
    verificationSent: "تم إرسال رسالة التحقق!",
    checkInbox: "تحقق من بريدك الوارد واضغط على الرابط للتحقق من بريدك الإلكتروني.",
    iVerifiedRefresh: "لقد تحققت — تحديث",
    resendCooldown:
      "تم إرسال رسالة تحقق مؤخراً. يرجى الانتظار دقيقة قبل المحاولة مرة أخرى.",
  },
  account: {
    // Dashboard
    hello: "مرحباً،",
    notLoggedIn: "لم يتم تسجيل الدخول",
    notLoggedInMessage: "يرجى تسجيل الدخول للوصول إلى لوحة حسابك.",
    backToDashboard: "العودة إلى لوحة الحساب",
    ordersCard: "الطلبات",
    ordersCardDesc: "عرض طلباتك وتتبعها",
    profileCard: "الملف الشخصي",
    profileCardDesc: "عرض معلومات ملفك الشخصي",
    changePassword: "تغيير كلمة المرور",
    changePasswordDesc: "تحديث كلمة المرور الخاصة بك",
    // Complete-account (credentials) card
    completeAccountTitle: "أكمل حسابك",
    completeAccountMessage:
      "لقد سجّلت برقم الجوال فقط. أضف بريداً إلكترونياً وكلمة مرور لتتمكن من تسجيل الدخول من أجهزة أخرى.",
    addEmail: "إضافة البريد",
    emailAdded: "تمت إضافة البريد الإلكتروني.",
    addEmailFailed: "تعذر إضافة البريد الإلكتروني",
    setPasswordLabel: "تعيين كلمة مرور",
    setPassword: "تعيين كلمة المرور",
    passwordSet: "تم تعيين كلمة المرور.",
    setPasswordFailed: "تعذر تعيين كلمة المرور",
    saving: "جاري الحفظ…",
    // Profile
    profileInformation: "معلومات الملف الشخصي",
    editProfile: "تعديل الملف الشخصي",
    name: "الاسم",
    email: "البريد الإلكتروني",
    mobile: "الجوال",
    mobileNumber: "رقم الجوال",
    notSet: "غير محدد",
    userId: "معرّف المستخدم",
    updateProfile: "تحديث الملف الشخصي",
    updating: "جاري التحديث...",
    profileUpdated: "تم تحديث الملف الشخصي بنجاح! جاري التحويل...",
    profileUpdateFailed: "فشل تحديث الملف الشخصي. يرجى المحاولة مرة أخرى.",
    invalidInput: "تم اكتشاف إدخال غير صالح أو ضار: ",
    loadingCountries: "جاري تحميل الدول...",
    loadingDivisions: "جاري تحميل المناطق...",
    loadingCities: "جاري تحميل المدن...",
    selectCountryFirst: "اختر الدولة أولاً",
    noDivisions: "لا توجد مناطق متاحة",
    noCities: "لا توجد مدن متاحة",
    selectCityOptional: "اختر المدينة/الحي (اختياري)",
    selectDivisionHint: "اختر المنطقة أو الولاية",
    selectedValue: "المحدد: {name}",
    cityOptionalHint: "اختياري: اختر مدينة أو حياً محدداً",
    // Security / password
    currentPassword: "كلمة المرور الحالية",
    currentPasswordPlaceholder: "أدخل كلمة المرور الحالية",
    confirmNewPasswordLabel: "تأكيد كلمة المرور الجديدة",
    currentPasswordRequired: "كلمة المرور الحالية مطلوبة",
    newPasswordRequired: "كلمة المرور الجديدة مطلوبة",
    newPasswordMin: "يجب أن تتكون كلمة المرور الجديدة من 8 أحرف على الأقل",
    newPasswordSame: "يجب أن تكون كلمة المرور الجديدة مختلفة عن الحالية",
    invalidCurrentPassword: "صيغة كلمة المرور الحالية غير صالحة",
    invalidNewPassword: "كلمة المرور الجديدة غير صالحة",
    securityTipTitle: "نصيحة أمنية:",
    securityTipBody:
      "استخدم كلمة مرور قوية من 8 أحرف على الأقل، تتضمن أحرفاً كبيرة وصغيرة وأرقاماً ورموزاً خاصة.",
    passwordUpdated: "تم تحديث كلمة المرور بنجاح! جاري العودة إلى الملف الشخصي...",
    passwordUpdateFailed: "فشل تحديث كلمة المرور. يرجى المحاولة مرة أخرى.",
    // Orders
    myOrders: "طلباتي",
    noOrdersYet: "لا توجد طلبات بعد",
    noOrdersMessage: "لم تقم بأي طلبات حتى الآن.",
    showingOrders: "عرض {from} - {to} من أصل {total} طلب",
    orderNumberTitle: "طلب رقم {number}",
    orderNumber: "رقم الطلب",
    date: "التاريخ",
    items: "العناصر",
    payment: "الدفع",
    loadingOrders: "جاري تحميل الطلبات...",
    fetchOrdersFailed: "تعذر جلب الطلبات",
    loadOrdersFailed: "تعذر تحميل الطلبات. يرجى المحاولة مرة أخرى.",
    businessIdRequired: "معرّف المتجر مطلوب لجلب الطلبات.",
    pageOf: "صفحة {current} من {last}",
    previous: "السابق",
    next: "التالي",
    backToOrders: "العودة إلى الطلبات",
    orderNotFound: "الطلب غير موجود",
    fetchOrderDetailsFailed: "تعذر جلب تفاصيل الطلب",
    loadOrderDetailsFailed: "تعذر تحميل تفاصيل الطلب. يرجى المحاولة مرة أخرى.",
    // Order / payment statuses (backend values)
    statusPending: "قيد الانتظار",
    statusProcessing: "قيد المعالجة",
    statusConfirmed: "مؤكد",
    statusCompleted: "مكتمل",
    statusCancelled: "ملغي",
    statusShipped: "تم الشحن",
    statusDelivered: "تم التوصيل",
    statusPaid: "مدفوع",
    statusFailed: "فشل",
    statusRefunded: "مسترد",
    statusOnHold: "قيد التعليق",
    // Addresses
    myAddresses: "عناويني",
    addressCountOne: "عنوان واحد",
    addressCount: "{count} عناوين",
    noAddresses: "لا توجد عناوين محفوظة",
    noAddressesMessage: "أضف عنواناً جديداً لحفظه للطلبات القادمة",
    editAddress: "تعديل العنوان",
    updateAddress: "تحديث العنوان",
    addAddress: "إضافة العنوان",
    adding: "جاري الإضافة...",
    deleting: "جاري الحذف...",
    edit: "تعديل",
    delete: "حذف",
    confirm: "تأكيد",
    deleteAddressTitle: "حذف العنوان",
    deleteAddressConfirm:
      "هل أنت متأكد من حذف هذا العنوان؟ لا يمكن التراجع عن هذا الإجراء.",
    fetchAddressesFailed: "تعذر جلب العناوين",
    loadAddressesFailed: "تعذر تحميل العناوين. يرجى المحاولة مرة أخرى.",
    deleteAddressFailed: "تعذر حذف العنوان. يرجى المحاولة مرة أخرى.",
    updateAddressFailed: "تعذر تحديث العنوان",
    addAddressFailed: "تعذر إضافة العنوان",
    addressLabelPlaceholder: "مثال: المنزل، العمل...",
    streetAddressPlaceholder: "عنوان الشارع",
    addressLine2Placeholder: "شقة، جناح، إلخ (اختياري)",
    county: "المحافظة",
    countryUnitedKingdom: "المملكة المتحدة",
    countryUnitedStates: "الولايات المتحدة",
    countryCanada: "كندا",
    countryAustralia: "أستراليا",
    countryIreland: "أيرلندا",
    countrySaudiArabia: "المملكة العربية السعودية",
    countryBangladesh: "بنغلاديش",
    // Wishlist
    myWishlist: "قائمة المفضلة",
    itemCountOne: "منتج واحد",
    itemCount: "{count} منتجات",
    wishlistEmpty: "قائمة المفضلة فارغة",
    wishlistEmptyMessage: "ابدأ بإضافة منتجاتك المفضلة لحفظها لوقت لاحق",
    gridView: "عرض شبكي",
    tilesView: "عرض قائمة",
    clearWishlist: "مسح المفضلة",
    clearing: "جاري المسح...",
    clearWishlistConfirm:
      "هل أنت متأكد من مسح قائمة المفضلة بالكامل؟ لا يمكن التراجع عن هذا الإجراء.",
    clearWishlistFailed: "تعذر مسح قائمة المفضلة. يرجى المحاولة مرة أخرى.",
    removeFromWishlist: "إزالة من المفضلة",
    removing: "جاري الإزالة...",
    removeWishlistFailed: "تعذر إزالة المنتج من المفضلة. يرجى المحاولة مرة أخرى.",
    addedOn: "أُضيف في {date}",
    viewProduct: "عرض المنتج",
    loadingWishlist: "جاري تحميل المفضلة...",
    fetchWishlistFailed: "تعذر جلب قائمة المفضلة",
    loadWishlistFailed: "تعذر تحميل قائمة المفضلة. يرجى المحاولة مرة أخرى.",
    // Common
    noAccessToken: "لم يتم العثور على رمز الدخول. يرجى تسجيل الدخول مرة أخرى.",
  },
  footer: {
    aboutUs: "من نحن",
    contactUs: "اتصل بنا",
    privacyPolicy: "سياسة الخصوصية",
    termsOfService: "شروط الخدمة",
    returnPolicy: "سياسة الإرجاع",
    shippingInfo: "معلومات الشحن",
    followUs: "تابعنا",
    newsletter: "النشرة الإخبارية",
    subscribeNewsletter: "اشترك في نشرتنا الإخبارية",
    enterEmail: "أدخل بريدك الإلكتروني",
    subscribe: "اشترك",
  },
  guestCheckout: guestCheckoutAr,
};
